module.exports = __webpack_public_path__ + "static/media/img2.6ff89063.jpg";